import { render, staticRenderFns } from "./EduTypeStat.vue?vue&type=template&id=44f537b6&"
import script from "./EduTypeStat.vue?vue&type=script&lang=js&"
export * from "./EduTypeStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports